<template>
  <div>
    <register-header />
    <div class="register-content">
      <el-form ref="form" class="register-box" :model="form" :rules="rules" label-width="100px">
        <span class="box-title">注册账号</span>
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="form.phone"
            placeholder="请输入您的手机号"
            maxlength="11"
            size="medium"
            clearable
          />
        </el-form-item>
        <el-form-item label="图形验证码" prop="captcha">
          <div class="captcha-container">
            <el-input
              v-model="form.captcha"
              placeholder="请输入右侧验证码"
              maxlength="5"
              size="medium"
              clearable
            />
            <img class="box-captcha" :src="base64" @click="getCodeImg">
          </div>
        </el-form-item>
        <el-form-item label="短信验证码" prop="code">
          <div class="captcha-container">
            <el-input
              v-model="form.code"
              placeholder="请输入您收到的验证码"
              maxlength="6"
              size="medium"
              clearable
            />
            <div class="box-captcha box-code" :class="countdown ? 'box-pointer-no' : 'box-pointer'" @click="getPhoneCode">
              {{ secondTxt }}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="用户名" prop="username">
          <el-input
            v-model="form.username"
            placeholder="5-20个字符，允许字母、数字和中划线'-'"
            :maxlength="20"
            minlength="5"
            size="medium"
            auto-complete="new-password"
            clearable
          />
        </el-form-item>
        <el-form-item label="创建密码" prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="8-20位，必须包含大小写字母、字符或数字的至少三种"
            :maxlength="20"
            size="medium"
            auto-complete="new-password"
            clearable
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="repeat">
          <el-input
            v-model="form.repeat"
            type="password"
            placeholder="8-20位，必须包含大小写字母、字符或数字的至少三种"
            :maxlength="20"
            size="medium"
            clearable
          />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="form.email"
            type="email"
            placeholder="请填写您的邮箱"
            maxlength="40"
            size="medium"
            clearable
          />
        </el-form-item>
        <div class="box-submit" @click="handleSubmit">提交注册</div>
        <div class="box-bottom">
          <el-checkbox v-model="checked" />
          <span class="box-read">我已阅读并同意</span>
          <span class="box-agreement" @click="dialogVisible = true">
            《用户注册协议》
          </span>
        </div>
      </el-form>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="90%" top="5vh" :modal-append-to-body="false">
      <iframe class="frame-content" src="static/agreement.html" />
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import {
  getCaptcha,
  getAuthCode,
  register,
  memberLogin,
  memberInfo,
  checkUserNameApi,
  checkPhoneApi
} from '@/api/member'
import Qs from 'qs'
import JSEncrypt from 'jsencrypt'
import RegisterHeader from './RegisterHeader.vue'
import { setToken, setRefreshToken } from '@/utils/auth'

// 设置公钥
const jsencrypt = new JSEncrypt()
const rsaPublicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCMFYpa2y3AU9GnTQgmgjjWjNNsUBxuR5pNpAVBHpZ/PS49a/E9jX6rNabnR/lfkOM7BoCIcizzLln8EYUmqpME7+Eq/nk4F18q1R9apfjiDkRx/3tzxslrA4ZHHV2gBpRyUDxew4YceAHpDoVgZGWMseqLXHCvGzmogtF87cVbuwIDAQAB'

jsencrypt.setPublicKey(rsaPublicKey)

export default {
  name: 'RegisterOrdinary',
  components: { RegisterHeader },
  data() {
    // 校验手机号
    const validatePhone = async(rule, value, callback) => {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!reg.test(value)) {
        return callback(new Error('请输入正确手机号'))
      }
      const params = { phone: value }
      const res = await checkPhoneApi(Qs.stringify(params))
      if (res.data === 1) {
        // 1-已经存在 0-不存在
        return callback(new Error('手机号已存在'))
      }
      callback()
    }
    // 校验用户名
    const validateName = async(rule, value, callback) => {
      const reg = /^[a-zA-Z0-9-]+$/
      if (!reg.test(value)) {
        return callback(new Error('用户名只可输入字母、数字及中划线"-"'))
      }
      const params = { username: value }
      const res = await checkUserNameApi(Qs.stringify(params))
      if (res.data === 1) {
        // 1-已经存在 0-不存在
        return callback(new Error('用户名已存在'))
      }
      callback()
    }
    // 校验密码
    const validatePassword = (rule, value, callback) => {
      // 小写字母
      const regLowerLetter = /[a-z]/
      // 大写字母
      const regUpperLetter = /[A-Z]/
      // 数字
      const regNum = /[0-9]/
      // 特殊字符
      const regCharacter = /[*?!&￥$%^#,./@";:><\[\]}{\-=+_\\|》《。，、？’‘“”~ `]/
      const regRes = [regLowerLetter, regUpperLetter, regNum, regCharacter].filter(item => item.test(value))
      if (regRes.length < 3) {
        return callback(new Error('密码须包含大小写字母、字符或数字的至少三种'))
      }
      if (this.form.repeat && value !== this.form.repeat) {
        return callback(new Error('两次密码输入不一致'))
      }
      callback()
    }
    // 校验二次确认密码
    const validateRepeat = (rule, value, callback) => {
      if (this.form.password && value !== this.form.password) {
        return callback(new Error('两次密码输入不一致'))
      }
      callback()
    }
    // 校验邮箱
    const validateEmail = (rule, value, callback) => {
      const reg = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/
      if (value && !reg.test(value)) {
        return callback(new Error('邮箱格式不正确'))
      }
      callback()
    }

    return {
      base64: '', // 图形验证码
      captchaKey: '', // 图形验证码key
      checked: false, // 是否选中“我已阅读并同意《用户注册协议》”
      countdown: null, // 短信验证码倒计时
      secondTxt: '获取验证码',
      dialogVisible: false,
      form: {
        phone: '',
        captcha: '',
        code: '',
        username: '',
        password: '',
        repeat: '',
        email: ''
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 5, message: '用户名至少5个字符', trigger: 'blur' },
          { validator: validateName, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 8, message: '请输入至少8位密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        repeat: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validateRepeat, trigger: 'blur' }
        ],
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getCodeImg()
  },
  destroyed() {
    clearInterval(this.countdown)
  },
  methods: {
    ...mapActions(['setUserInfo']),
    // 获取图形验证码
    async getCodeImg() {
      const res = await getCaptcha()
      this.base64 = res.data.captchaImgData
      this.captchaKey = res.data.key
    },
    async handleSubmit() {
      if (!this.checked) {
        return this.$Message.error('请阅读并同意《用户注册协议》')
      }
      this.$refs['form'].validate(async(valid) => {
        if (valid) {
          const params = {
            authCode: this.form.code,
            captcha: this.form.captcha,
            email: this.form.email,
            password: jsencrypt.encrypt(this.form.password),
            telephone: this.form.phone,
            username: this.form.username,
            captchaKey: this.captchaKey
          }
          const registerRes = await register(Qs.stringify(params))
          if (registerRes.code === 200) {
            // 调用登录接口获取token，后面成为企业用户提交审核需要
            const loginRes = await memberLogin(Qs.stringify(params))
            if (loginRes.code === 200) {
              const token = loginRes.data.tokenHead + loginRes.data.token
              setToken(token)
              setRefreshToken(loginRes.data.refreshToken)
              const memberInfoRes = await memberInfo()
              this.setUserInfo(memberInfoRes.data)
              this.$Message.success('注册成功')
              this.$router.push('/registerEnterprise')
            } else {
              // 登录失败，刷新验证码
              this.getCodeImg()
            }
          } else {
            // 注册失败，刷新验证码
            this.getCodeImg()
          }
        }
      })
    },
    // 获取手机验证码
    async getPhoneCode() {
      // 倒计时进行中，不可点击
      if (this.countdown) {
        return false
      }
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!reg.test(this.form.phone)) {
        return this.$Message.error('请输入正确手机号')
      }
      const res = await getAuthCode(this.form.phone)
      if (res.code === 200) {
        this.$Message.success('短信验证码已发送')
        let sec = 60
        this.secondTxt = sec + '后重试'
        this.countdown = setInterval(() => {
          if (sec > 1) {
            sec--
            this.secondTxt = sec + '后重试'
          } else {
            clearInterval(this.countdown)
            this.countdown = null
            this.secondTxt = '获取验证码'
          }
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>
.captcha-container {
  display: flex;
  align-items: center;
}
.register-content {
  background-color: #f5f5f5;
  padding: 36px 0;
}
.register-box {
  margin: 0 auto;
  width: 700px;
  background-color: white;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  padding: 30px 68px;
}
.box-title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #3d3d3d;
  margin-bottom: 20px;
}
.box-captcha {
  height: 36px;
  width: 130px;
  margin-left: 12px;
  cursor: pointer;
}
.box-pointer {
  cursor: pointer;
}
.box-pointer-no {
  cursor: default;
}
.box-code {
  border-radius: 4px;
  border: 1px solid #f6713d;
  color: #f6713d;
  font-size: 14px;
  text-align: center;
  line-height: 36px;
}
.box-submit {
  margin-top: 18px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  border-radius: 4px;
  background: #f6713d;
  color: white;
  font-size: 14px;
  cursor: pointer;
}
.box-bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 18px;
}
.box-bottom span {
  font-size: 14px;
}
.box-read {
  color: black;
  margin-left: 8px;
}
.box-agreement {
  color: #f6713d;
  cursor: pointer;
}
.el-checkbox >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #f6713d;
  border-color: #f6713d;
}
.el-checkbox >>> .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #f6713d;
}
.el-checkbox >>> .el-checkbox__inner:hover {
  border-color: #f6713d;
}
.el-input >>> .el-input__inner:focus {
  border-color: #f6713d;
}
.frame-content {
  width: 100%;
  height: 75vh;
}
</style>
